import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { DEFAULT_ACTIVITY_FILTERS, ACTIVITY_FILTER } from '@/utils/constants';
import ActivitySearchFilterAccordion from './activity-search-filter-accordion/activity-search-filter-accordion';
import CenturySkills from '@/components/cards/century-skills/century-skills';
import PopupFilterLayout from '../../popup-filter-layout/popup-filter-layout';

@Component({
    name: 'activity-search-filter',
    components: {
        'material-icon': GoogleMaterialIcon,
        'activity-search-filter-accordion': ActivitySearchFilterAccordion,
        'century-skills': CenturySkills,
        'popup-filter-layout': PopupFilterLayout,
    },
})

export default class ActivitySearchFilter extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    private isShowFilterPopup: boolean = false;

    private isShowPullup: boolean = false;

    @Prop()
    private filterList?: any;

    @Prop()
    private filterParams!: any;

    private enableOtherFilter: boolean = false;

    private defaultActivityFilter: any = DEFAULT_ACTIVITY_FILTERS;

    private activityFilter: any = ACTIVITY_FILTER;

    @Watch('filterList', { deep: true })
    private onChangeFilterList(value: any) {
        this.isShowFilterPopup = (this.filterList && this.filterList.course
            && this.filterList.course.length > 0) ? true : false;
    }

    private get isCapLibrary() {
        return this.$access.isCapLibrary || false;
    }

    private get showCentury() {
        return this.activityFilter.find((item: any) => item.code === '21-century-skills' && item.isActive);
    }

    private onSelectCategory(list: any, filter: any) {
        this.enableOtherFilter = filter.code === 'category' ? false : true;
        this.$emit('onSelectCategory', list, filter);
    }


    private created() {
        if (this.$access.isCapLibrary) {
            this.defaultActivityFilter = DEFAULT_ACTIVITY_FILTERS.filter((item: any) => item.code !== 'course');
        }
    }


}
